export default "__VITE_ASSET__D7ePdOKW__"